export default __webpack_public_path__ + "static/media/Etherfish3.0b9910fe.gif";